var getNextState = function (machine, state, event) {
    // Final state
    var _a, _b, _c, _d, _e;
    if (((_a = machine.states[state]) === null || _a === void 0 ? void 0 : _a.type) === 'FINAL')
        return state;
    // Explicit transitions
    if (((_b = machine.states[state].on) === null || _b === void 0 ? void 0 : _b[event]) !== undefined)
        return (_c = machine.states[state].on) === null || _c === void 0 ? void 0 : _c[event];
    // Global transitions
    if (((_d = machine.on) === null || _d === void 0 ? void 0 : _d[event]) !== undefined)
        return (_e = machine.on) === null || _e === void 0 ? void 0 : _e[event];
    // Default
    return state;
};
var transitionStateMachine = function (machine, state, event) {
    var nextState = getNextState(machine, state, event);
    return {
        nextState: nextState,
        prevState: state,
        changed: nextState !== state,
        event: event,
    };
};
export { transitionStateMachine };
//# sourceMappingURL=index.js.map